/**
 * @ngdoc Controller
 * @name AlarmsSettingsController
 */
import { REALTIME_INDICATOR } from '../../../mqtt/mqtt.service';

(function() {
    'use strict';

    angular.module('vrm.core')
        .controller('AlarmLogsController', AlarmLogsController);

    /**
     * @constructor
     * @ngInject
     */
    function AlarmLogsController(
        $log,
        $scope,
        $stateParams,
        $state,
        $q,
        $timeout,
        ApiService,
        VrmModalService,
        vrmNotificationsService,
        vrmNotificationType,
        moment,
        locale,
        InstallationsService,
        MQTTRealtimeService,
        TablePaginateService,
        $window
    ) {
        $log.info('AlarmLogsController');


        $scope.mpptAnchors = {
            2: "err_2_-_battery_voltage_too_high",
            3: "err_3_err_4_-_remote_temperature_sensor_failure",
            4: "err_3_err_4_-_remote_temperature_sensor_failure",
            5: "err_5_-_remote _temperature_sensor_failure_connection_lost",
            6: "err_6_err_7_-_remote_battery_voltage_sense_failure",
            7: "err_6_err_7_-_remote_battery_voltage_sense_failure",
            8: "err_8_-_remote_battery_voltage_sense_failure_connection_lost",
            11: "err_11_-_battery_high_ripple_voltage",
            14: "err_14_-_battery_low_temperature",
            17: "err_17_-_controller_overheated_despite_reduced_output_current",
            18: "err_18_-_controller_over-current",
            20: "err_20_-_maximum_bulk-time_exceeded",
            21: "err_21_-_current_sensor_issue",
            22: "err_22_err_23_-_internal_temperature_sensor_failure",
            23: "err_22_err_23_-_internal_temperature_sensor_failure",
            24: "err_24_-_fan_failure",
            26: "err_26_-_terminal_overheated",
            27: "err_27_-_charger_short_circuit",
            28: "err_28_-_power_stage_issue",
            29: "err_29_-_over-charge_protection",
            33: "err_33_-_pv_over-voltage",
            34: "err_34_-_pv_over-current",
            35: "err_35_-_pv_over-power",
            38: "err_38_err_39_-_pv_input_shutdown",
            39: "err_38_err_39_-_pv_input_shutdown",
            40: "err_40_-_pv_input_failed_to_shutdown",
            41: "err_41_-_inverter_shutdown_pv_isolation",
            42: "err_42_-_inverter_shutdown_ground_fault",
            43: "err_43_-_inverter_shutdown_ground_fault",
            50: "err_50_err_52_-_inverter_overload_inverter_peak_current",
            51: "err_51_-_inverter_temperature_too_high",
            52: "err_50_err_52_-_inverter_overload_inverter_peak_current",
            53: "err_53_-_inverter_output_voltage",
            54: "err_54_-_inverter_output_voltage",
            55: "err_55_err_56_err_58_-_inverter_self_test_failed",
            56: "err_55_err_56_err_58_-_inverter_self_test_failed",
            57: "err_57_-_inverter_ac_voltage_on_output",
            58: "err_55_err_56_err_58_-_inverter_self_test_failed",
            65: "information_65_-_communication_warning",
            66: "information_66_-_incompatible_device",
            67: "err_67_-_bms_connection_lost",
            68: "err_68_-_network_misconfigured",
            114: "err_114_-_cpu_temperature_too_high",
            116: "err_116_-_calibration_data_lost",
            117: "err_117_-_incompatible_firmware",
            119: "err_119_-_settings_data_lost",
            121: "err_121_-_tester_fail",
            200: "err_200_-_internal_dc_voltage_error",
            201: "err_201_-_internal_dc_voltage_error",
            203: "err_203_err_205_err_212_err_215_-_internal_supply_voltage_error",
            205: "err_203_err_205_err_212_err_215_-_internal_supply_voltage_error",
            212: "err_203_err_205_err_212_err_215_-_internal_supply_voltage_error",
            215: "err_203_err_205_err_212_err_215_-_internal_supply_voltage_error"
        }

        $scope.VEBusAnchors = {
            1: "error_1_-_device_is_switched_off_because_one_of_the_other_phases_in_the_system_has_switched_off",
            2: "error_2_-_new_and_old_type_mk2_protocol_mixed_in_the_system",
            3: "error_3_-_not_all_or_more_than_the_expected_devices_were_found_in_the_system",
            4: "error_4_-_no_other_device_found",
            5: "error_5_-_overvoltage_on_ac_out",
            6: "error_6_-_error_in_ddc_program",
            7: "error_7_-_external_device_connected_assistant_required",
            8: "error_8_-_ground_relay_test_failed",
            10: "error_10_-_system_time_synchronisation_problem",
            11: "error_11_-_relay_test_fault_-_installation_error_or_possibly_relay_failure",
            12: "error_12_-_config_mismatch_with_2nd_mcu",
            14: "error_14_-_device_cannot_transmit_data",
            15: "error_15_-_vebus_combination_error",
            16: "error_16_-_vebus_dongle_is_missing",
            17: "error_17_-_phase_master_missing",
            18: "error_18_-_ac_over-voltage_on_the_output_of_a_slave_while_switched_off",
            19: "error_19_-_slave_does_not_have_ac_input",
            20: "error_20_-_configuration_mismatch",
            22: "error_22_-_this_device_cannot_function_as_a_slave",
            24: "error_24_-_switch-over_system_protection_initiated",
            25: "error_25_-_firmware_incompatibility",
            26: "error_26_-_internal_error"
        }

        $scope.dropdownOptions = []
        $scope.showMenu = {}
        $scope.table = TablePaginateService.setup(
            (page, count) => ApiService.call2(
                `/installations/${$stateParams.id}/alarm-log?page=${page}&count=${count}`,
                null,
                { method: "GET", skipResultChecks: true }
            ), { count: 3000 }
        );

        $scope.realtimeIndicator = REALTIME_INDICATOR.OFFLINE;

        $scope.updateRealtimeIndicator = function (indicator) {
            // trick angular with a microtask to update the realtime indicator
            $timeout(() => {
                $scope.realtimeIndicator = indicator;
            })
        };

        $q.all([InstallationsService.getInstallation($stateParams.id)]).then(function(result) {
            var installation = result[0];
            if (InstallationsService.canMaintainRealtimeCommunication()) {
                MQTTRealtimeService.observeRealtime(installation.identifier, $scope.updateRealtimeIndicator);
            } else {
                $scope.realtimeIndicator = REALTIME_INDICATOR.OFFLINE;
            }
        });

        $scope.getType = function(type)
        {
            if (type == "float" || type == "enum")
                return "Alarm rule";
            if (type == "device missing" || type == "alarm monitor")
                return "Automatic monitoring";
            return type.charAt(0).toUpperCase() + type.slice(1);
        };

        $scope.goToAdvanced = function (startTime) {
            if(!startTime) return;
            let todayDate = moment().format("MM/DD/YYYY");
            let alarmTime = moment.unix(startTime);

            var start = alarmTime.startOf('day').valueOf();

            // If alarm is today, set the endTime of filter the same day at 23:59:59 instead of next day 00:00
            // to avoid unexpected behaviour of the filter
            var end = (alarmTime.format("MM/DD/YYYY") === todayDate)?
                alarmTime.endOf('day').subtract(1, 's').valueOf() :
                alarmTime.endOf('day').valueOf();

            $state.go('base.installation.advanced', { start: start, end: end });
        }

        $scope.goToAlarmRules = function () {
            $state.go('base.installation.settings.alarms');
        }

        $scope.clearAlarm = function (alarm, event) {
            if (!alarm) return;

            var target = event.currentTarget.closest('.vrm-table__tr--alert');

            VrmModalService.openClearAlarmModal($scope, target, function() {
                ApiService.clearAlarm($stateParams.id, { alarmId: alarm.idAlarm }).then(res => {
                    if (res.data && res.data.success) {
                        vrmNotificationsService.add({ type: vrmNotificationType.SUCCESS, message: locale.getString('common.ok') });
                    } else {
                        vrmNotificationsService.add({ type: vrmNotificationType.ERROR, message: locale.getString('core.unknown_error') });
                    }
                }).finally(() => {
                    $state.reload();
                })
            });
        }

        $scope.getRowDescription = function (row) {
            let isNoDataAlarm = row.description.startsWith('No data alarm');
            let noDataAlarmDescription = 'VRM logging stopped';
            return (isNoDataAlarm ? noDataAlarmDescription : row.description) + (row.nameEnum ? ': ' + row.nameEnum : '')
        }

        $scope.getErrorLink = function (row) {
            if (row.description.startsWith('Error code')  && row.nameEnum.startsWith("#")) {
                //    mppt error
                let error_code = row.nameEnum.replaceAll("#","").split(" ")[0]
                return "https://www.victronenergy.com/live/mppt-error-codes#" + $scope.mpptAnchors[error_code]
            }else if (row.description.startsWith("VE.Bus Error")) {
            //    VE bus error
                let error_code = row.nameEnum.replaceAll("VE.Bus Error ", "").split(":")[0]
                return "https://www.victronenergy.com/live/ve.bus:ve.bus_error_codes#" + $scope.VEBusAnchors[error_code]
            }
            return "#"
        }

        $scope.hasLink = function (row) {
            return (row.description.startsWith('Error code')  && row.nameEnum.startsWith("#")) || (row.description.startsWith('VE.Bus Error'));
        }

        function findPositionedParent(element) {
            let parentElement = element.parentNode;

            while (parentElement) {
              const position = getComputedStyle(parentElement).position;

              if (position === 'relative' || position === 'absolute') {
                return parentElement;
              }

              parentElement = parentElement.parentNode;
            }

            return null; // Return null if no positioned parent is found
          }

        $scope.showDropdownMenu = function(alarm, event) {
            // Fetch the DOM elements for the menu and the table
            let menuElement =  event.target.parentNode.querySelector('.kebab-dropdown-menu')
            let tableElement =  findPositionedParent(menuElement);
            // Get bounding boxes for the menu and the table
            let buttonRect = event.target.getBoundingClientRect();
            let tableRect = tableElement.getBoundingClientRect()

            // Calculate the distance between the right table bound and the button. This is necessary
            // since the table has absolute positioning.
            let offsetRight = tableRect.right - buttonRect.right;

            menuElement.style.right = offsetRight + 'px';
            menuElement.style.marginTop = '20px';

            event.stopPropagation();

            // Save row menu status if exists before resetting it
            const showStatus = !$scope.showMenu[alarm.idAlarm];
            $scope.showMenu = {};
            $scope.showMenu[alarm.idAlarm] = showStatus;

            const options = []
            locale.ready('alarms').then(function() {
                options.push({name: locale.getString('alarms.goto_installation_advanced'), action:() => $scope.goToAdvanced(alarm.started)})
                if($scope.hasLink(alarm)) {
                    options.push({name: locale.getString('alarms.view_alarm_description'), action:() => window.open($scope.getErrorLink(alarm))});
                }
                if (alarm.isActive) {
                    options.push({name: locale.getString('alarms.clear'), action:() => {
                        $scope.clearAlarm(alarm,event)
                    }})
                }
                $scope.dropdownOptions = options
            })
        }

        // Close the menu when clicking outside the menu
        $timeout(function () {
            angular.element($window).on('pointerdown', function(e) {
                if (e.target.parentNode.id === 'dropdownMenu') return;
                $scope.$apply(function() {
                    $scope.showMenu = {};
                });
            });

            angular.element($window).on('pointerup', function(e) {
                $scope.$apply(function() {
                    $scope.showMenu = {};
                });
            });

            angular.element($window).on('touchmove', function(e) {
                $scope.$apply(function() {
                    $scope.showMenu = {};
                });
            });

            angular.element($window).on('resize', function(e) {
                $scope.$apply(function() {
                    $scope.showMenu = {};
                });
            });

            $scope.$on('$destroy', function() {
                angular.element($window).off('pointerup');
                angular.element($window).off('pointerdown');
                angular.element($window).off('touchmove');
                angular.element($window).off('resize');
            });
        })
    }

})();
